import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const ShiftAssistant      = () => import('@/views/shift-schedule/components/assistant/ShiftAssistant.vue');
const ShiftAssistantIntro = () => import('@/views/shift-schedule/components/assistant/ShiftAssistantIntro.vue');
const ShiftAssistantOutro = () => import('@/views/shift-schedule/components/assistant/ShiftAssistantOutro.vue');

const ShiftScheduleCalendar = () => import('../views/shift-schedule/ShiftScheduleCalendar.vue');
const WorkGroupEdit         = () => import('../views/shift-schedule/WorkGroupEdit.vue');
const ShiftEdit             = () => import('../views/shift-schedule/ShiftEdit.vue');
const ShiftAdd              = () => import('../views/shift-schedule/ShiftAdd.vue');
const ShiftList             = () => import('../views/shift-schedule/ShiftList.vue');

let meta: MetaData = {
    module: 'employee',
    assistant: {
        key: 'shift_schedule',
        steps: [
            {
                component: ShiftAssistantIntro,
            },
            {
                title: 'Schichtplanung',
                titleIcon: 'table_chart',
                component: ShiftAssistant,
            },
            {
                component: ShiftAssistantOutro,
            },
        ],
    },
};

let shiftSchedule: RouteRecordRaw[] = [
    {
        name: 'shift-schedule-calendar',
        path: '/employee/shift-schedule/calendar/index/:date(\\d{4}-\\d{2}-\\d{2}|today)?/:id(\\d+)?',
        component: ShiftScheduleCalendar,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                date: route.params.date || 'today',
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'shift-schedule-work-group-add',
        path: '/employee/shift-schedule/work-group/add/:workGroupId?/:shiftId?/:wildcard*',
        component: WorkGroupEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                workGroupId: parseInt(route.params.workGroupId) || 0,
                shiftId: parseInt(route.params.shiftId) || 0,
            };
        },
    },
    {
        name: 'shift-schedule-work-group-edit',
        path: '/employee/shift-schedule/work-group/edit/:id/:wildcard*',
        component: WorkGroupEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {id: parseInt(route.params.id) || 0};
        },
    },
    {
        name: 'shift-schedule-shift-add',
        path: '/employee/shift-schedule/shift/add/:workGroupId/:date/:roleId(\\d+)?/:startTime(\\d{2}:\\d{2})?/:endTime(\\d{2}:\\d{2})?',
        component: ShiftAdd,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                workGroupId: parseInt(route.params.workGroupId) || 0,
                date: route.params.date,
                roleId: parseInt(route.params.roleId) || 0,
                startTime: route.params.startTime,
                endTime: route.params.endTime,
            };
        },
    },
    {
        name: 'shift-schedule-shift-edit',
        path: '/employee/shift-schedule/shift/edit/:id/:editDate/:wildcard*',
        component: ShiftEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                editDate: route.params.editDate,
            };
        },
    },
    {
        name: 'shift-schedule-shift-list',
        path: '/employee/shift-schedule/shift/list/:id?/:wildcard*',
        component: ShiftList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        path: '/employee/shift-schedule/:wildcard*',
        redirect: {name: 'shift-schedule-calendar'},
    },
];

export default shiftSchedule;